
import { Component, Vue, Prop, Watch, Emit, Ref, Model } from 'vue-property-decorator'
import { EnumCompleteType } from '@xt/client/enums/kindred-spirit'
import ConfirmModal from '../../ConfirmModal/index.vue'
import Phone from './Phone.vue'
import WeChat from './WeChat.vue'
import Summary from './Summary.vue'
import Specialty from './Specialty.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    ConfirmModal,
    Phone,
    WeChat,
    Summary,
    Specialty
  }
})
export default class SubLayout extends Vue {
  @Prop({ default: EnumCompleteType.PhoneNum }) readonly subType!: EnumCompleteType

  get options(): {
    title: string
    desc: string
    sub: string
  } {
    switch (this.subType) {
      case EnumCompleteType.PhoneNum:
        return {
          title: '完善手机号',
          desc: '手机号仅用于负责人联系与重要通知',
          sub: 'Phone'
        }
      case EnumCompleteType.WeChat:
        return {
          title: '完善微信号',
          desc: '填写常用微信号，方便负责人邀请你加入群聊',
          sub: 'WeChat'
        }
      case EnumCompleteType.Summary:
        return {
          title: '完善简介',
          desc: '填写个人简介，让桐学更快认识你',
          sub: 'Summary'
        }
      case EnumCompleteType.Specialty:
        return {
          title: '完善特长',
          desc: '选择你的特长，可添加多项',
          sub: 'Specialty'
        }
      default:
        return {
          title: '完善手机号',
          desc: '手机号仅用于负责人联系与重要通知',
          sub: 'Phone'
        }
    }
  }

  componentInstance: { onSubmit: () => Promise<boolean | null> } | null = null

  setComponentRef(el) {
    if (el) this.componentInstance = el
  }

  async onFinish() {
    if (this.componentInstance) {
      const res = await this.componentInstance.onSubmit()

      if (res === true) {
        this.$emit('finish', this.subType)
      }
    }
  }

  @Emit('back')
  handleCancel() {}
}
